import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import ShowMoreToggle from "./showMoreToggle";
import SquareCheckbox from "./squareCheckbox";

export default function ChoiceList({
  type = "checkbox",
  items = [],
  selected = [],
  onChange,
  showMoreCount = 8,
  disableZeros = true,
}) {
  const [expanded, setExpanded] = useState(false);

  const allItems = useMemo(() => (items || []).slice(), [items]);

  const visible = useMemo(
    () => (expanded ? allItems : allItems.slice(0, showMoreCount)),
    [expanded, allItems, showMoreCount]
  );

  const ControlComponent = type === "radio" ? Radio : SquareCheckbox;

  const radioName = type === "radio" ? `choice-radio-${Math.max(0, allItems.length)}` : undefined;

  return (
    <Stack spacing={0.25}>
      {visible.map((it) => {
        const checked = (selected || []).map(String).includes(String(it.id));
        const count = typeof it.count === "number" ? it.count : 0;
        const disabled = disableZeros ? count === 0 : false;

        return (
          <Box
            key={it.id}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              minHeight: 26,
            }}
          >
            <FormControlLabel
              control={
                <ControlComponent
                  name={radioName}
                  size="small"
                  disabled={disabled}
                  checked={checked}
                  onChange={() => onChange(it.id)}
                  sx={{
                    p: 0,
                    m: 0,
                    mr: 1,
                    color: "#BEBEBE",
                    "&.Mui-checked": { color: "#111" },
                    "& .MuiSvgIcon-root": {
                      width: 16,
                      height: 16,
                      borderRadius: "3px",
                    },
                  }}
                />
              }
              label={
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "120%",
                    fontFamily: "Zen Maru Gothic",
                    color: disabled ? "#BEBEBE" : "inherit",
                  }}
                >
                  {it.name}
                </Typography>
              }
              sx={{ m: 0 }}
            />
            <Typography
              variant="caption"
              sx={{
                fontSize: "14px",
                textAlign: "right",
                fontFamily: "Zen Maru Gothic",
                color: disabled ? "#BEBEBE" : "#8D8D8D",
                fontWeight: 500,
                lineHeight: "120%",
                minWidth: 28,
              }}
            >
              {count}
            </Typography>
          </Box>
        );
      })}

      {allItems.length > showMoreCount && (
        <ShowMoreToggle expanded={expanded} onToggle={setExpanded} />
      )}
    </Stack>
  );
}
